import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '@app/material.module';
import { CourseLogoComponent } from './course-logo.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MaterialModule],
  declarations: [CourseLogoComponent],
  exports: [CourseLogoComponent],
})
export class CourseLogoModule {}
